"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _operators = require("rxjs/operators");

var _reduxObservable = require("redux-observable");

var _uniq = _interopRequireDefault(require("lodash/uniq"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

var defaultUntil = function defaultUntil(action, sequence, expectedTypes) {
  return sequence.length === expectedTypes.length;
};

var defaultIsValidCandidate = function defaultIsValidCandidate(action, sequence, expectedTypes) {
  return action.type === expectedTypes[sequence.length];
};

var shouldRestart = function shouldRestart(until) {
  return function (action, sequence, expectedTypes) {
    return typeof until === 'string' && until === action.type || typeof until === 'function' && until(action, sequence, expectedTypes) || sequence && expectedTypes && sequence.length === expectedTypes.length;
  };
};
/**
 * Scans the action$ stream (observable) of redux actions, for a sequence
 * of actions specified in the array parameter <i>expectedTypes</i>.
 *
 * @example <caption> Scan for the sequence of actions of types
 * [A, B, C, D] </caption>
 *
 * const epic = action$
 *    .scanActionSequence([A, B, C, D], { consumeUntil: E })
 *    .subscribe((actions) => console.log('---Actions-- ', actions));
 *    ---Actions-- [{type: A, payload: p1}, {type: B}, {type: C}, {type: D}]
 *
 * @param {[string]} expectedTypes The array of consequtive action types
 * expected. Actions with different action types may interveal
 * if the default <i>isValidCandidate</i> parameter is not defined thus
 * the default one will be used.
 * @param {(action, sequence, expectedTypes) => boolean} options.consumeUntil
 * The function that if provided as parameter, will be called before an action
 * will be be added in the returned sequence of actions that satisfy the
 * <i>expectedTypes</i> sequence. If returns false the scanning of the
 * specific sequence will be interupted and restarted on this action as if it
 * is the first of the sequence to be tested and added.
 * If this parameter is not provided, the default implementation returns
 * interupted until the returned sequence contains all the expectedTypes.
 * @param {(action, sequence, expectedTypes) => boolean} options.isValidCandidate
 * The function that if provided as parameter, will be called before an action
 * added in the returned sequence of actions that satisfy the
 * <i>expectedTypes</i> sequence. If true is returned, the current action will
 * be added in the returned sequence.
 * If false is returned, the current action will not be added in the returned
 * sequence and the sequence will be returned unchanged for the next action.
 * @return {ActionsObservable} A new Observable of an array of actions that
 * defined in <i>expectedTypes</i> and in the order of <i>expectedTypes</i>.
 * @method scanActionSequenceOperator
 * @owner ActionsObservable
 */


var scanActionSequence = function scanActionSequence(expectedTypes) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$consumeUntil = _ref.consumeUntil,
      consumeUntil = _ref$consumeUntil === void 0 ? defaultUntil : _ref$consumeUntil,
      _ref$isValidCandidate = _ref.isValidCandidate,
      isValidCandidate = _ref$isValidCandidate === void 0 ? defaultIsValidCandidate : _ref$isValidCandidate;

  return function (src) {
    return src.pipe(_reduxObservable.ofType.apply(void 0, _toConsumableArray((0, _uniq["default"])(expectedTypes))), (0, _operators.scan)(function (sequence, action) {
      var nextSequence = shouldRestart(consumeUntil)(action, sequence, expectedTypes) ? [] : sequence;
      return isValidCandidate(action, nextSequence, expectedTypes) ? [].concat(_toConsumableArray(nextSequence), [action]) : nextSequence;
    }, []), (0, _operators.filter)(function (sequence) {
      return sequence.length === expectedTypes.length;
    }));
  };
};

var _default = scanActionSequence; //
// Test
//
// const someObservable = of(
//   { type: 'A'},
//   { type: 'D'},
//   { type: 'B'},
//   { type: 'A'},
//   { type: 'D'},
//   { type: 'A'},
//   { type: 'E'},
//   { type: 'E'},
//   { type: 'Z'},
//   { type: 'A'},
//   { type: 'A'},
// );
//
// console.log(
//   '------------- Starting Test ----------- ',
//    Math.floor(Math.random() * 10),
// );
//
// someObservable.pipe(
//   tap(action => console.log('---- Entering the tunnel --- ', action)),
//   scanActionSequence(['A', 'B', 'A']),
//   tap(sequence => console.log('---- Sequence found --- ', sequence)),
// ).subscribe(() => {});

exports["default"] = _default;